var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-contianer"},[_c('h1',[_vm._v("Your invoices")]),_c('v-data-table',{staticClass:"data-table",attrs:{"headers":_vm.headers,"items":_vm.invoices},scopedSlots:_vm._u([{key:"item.created",fn:function(ref){
var item = ref.item;
return [_c('p',[_vm._v(_vm._s(new Date(item.created * 1000).toLocaleDateString()))])]}},{key:"item.amount_due",fn:function(ref){
var item = ref.item;
return [_c('p',[_vm._v("$"+_vm._s((item.amount_due / 100).toFixed(2)))])]}},{key:"item.amount_paid",fn:function(ref){
var item = ref.item;
return [_c('p',[_vm._v("$"+_vm._s((item.amount_paid / 100).toFixed(2)))])]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"small":"","color":item.status === 'paid' ? 'success' : 'warning'}},[_vm._v(_vm._s(item.status.charAt(0).toUpperCase() + item.status.slice(1)))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }